
import { Component, Vue } from 'nuxt-property-decorator'

@Component({ name: 'EnvelopeLight' })
export default class EnvelopeLight extends Vue {}
